module.exports = __webpack_public_path__ + "img/a_giro_dx.8515cf4c.png";